import axios from 'axios';
import {
    CLIENT_REVIEW_QUOTE,
    ACCEPT_QUOTE_ITEMS,
    REJECT_QUOTE_URL,
    get_headers,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';


export default {
    name: 'QuoteAcceptance',
    mixins: [alert_mixin, formatting_mixins],
    data: () => ({
        selectedServices: [],
        // isAccordionOpen: false,
        openAccordions: [],
        quote_data: {
            quote_number: '',
            quote_status:'',
            issue_date: '',
            valid_until: '',
            client_name: '',
            client_email: '',
            main_service: [
                {
                id: null,
                name: '',
                qty: null,
                unit_price: 0.00,
                vat: 0.00,
                total: 0.00,
                sub_services: [
                    {
                        id: null,
                        name: '',
                        qty: null,
                        unit_price: null,
                        vat: null,
                        total: null
                    }
                ]
                },
            ],
            quote_id :null,
        },
        headers: get_headers(),
        lead_id: sessionStorage.getItem('lead_id'),
        decline_reason:'',
    }),
    mounted() {
        this.get_quotes();
    },
    computed: {
        calculated_totals() {
            const subtotal = this.quote_data.main_service.reduce(
                (sum, svc) =>
                this.selectedServices.some(sel => sel.service_package === svc.id)
                    ? sum + (Number(svc.total) || 0)
                    : sum,
                0
            );

            const vat = 0; // Can change later to: subtotal * 0.15
            return ({ subtotal, vat, total: subtotal + vat });
        }

    },
    methods: {

        get_quotes() {
            axios.get(CLIENT_REVIEW_QUOTE, {
                headers: this.headers,
                params: { lead_id: this.lead_id }
            })
            .then(response => {
                const quotes = response.data.data;
                if (quotes.length) {
                const q = quotes[0];
                this.quote_id = q.id;

                this.quote_data = {
                    id: q.id,
                    quote_number: q.quote_number,
                    quote_status: q.quote_status.code,
                    issue_date: this.format_date(q.date_issued),
                    valid_until: this.format_date(q.valid_until),
                    client_name: `${q.lead.user.first_name} ${q.lead.user.last_name}`,
                    client_email: q.lead.user.email,
                    main_service: this.map_main_services(q.items),
                    rejection_reason: q.rejections?.length ? q.rejections[0].reason : null,
                };
                }
            })
            .catch(error => {
                this.show_error("Error loading quotes: " + (error.response?.data?.message || error.message));
            });
        },

        map_main_services(items) {
            return items.map(item => ({
                id: item.main_service.id,
                name: item.main_service.name,
                qty: item.main_service.qty,
                unit_price: item.main_service.unit_price,
                vat: item.main_service.vat,
                total: item.main_service.total,
                sub_services: this.map_sub_services(item.main_service.sub_services)
            }));
        },

        map_sub_services(sub_services) {
            return sub_services.map(sub => ({
                id: sub.id,
                name: sub.name,
                qty: sub.qty,
                unit_price: sub.unit_price,
                vat: sub.vat,
                total: sub.total
            }));
        },

        format_date(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('en-ZA', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
        toggle_accordion(id) {
            const index = this.openAccordions.indexOf(id);
            if (index > -1) {
            this.openAccordions.splice(index, 1);
            }
            else {
            this.openAccordions.push(id);
            }
        },
        format_currency(amount) {
        if (amount === null || amount === undefined) return '-';
        return `R${amount.toFixed(2)}`;
        },
        accept_quote() {

            var accepted_quote_items = this.selectedServices
            const total =  Number(parseFloat(this.calculated_totals.total).toFixed(2));

            const payload = {
                accepted_quote_items : accepted_quote_items,
                quote_id: this.quote_id,
                total_amount: total,
            }

            axios.post(ACCEPT_QUOTE_ITEMS, payload,{
                headers: this.headers
            })
            .then(response => {
               if (response.data.status === 'success') {
                    this.show_success('Quote accepted successfully, your administrator will be in contact for the next step ');
                }
                else {
                    this.show_error('Error accepting quote: ' + response.data.message);
                }
            })
            .catch(error => {
                this.show_error("Error loading quotes: " + (error.response?.data?.message || error.message));
            });
        },
        decline_quote() {
            if (this.decline_reason === '' || this.decline_reason===null){
                this.show_info('Please provide your reason for declining this quote')
                return;
            }
            this.show_confirm(
            "Decline quote",
            "Are you sure you want to decline this quote?",
            () => {
                    const payload = {
                        quote_id: this.quote_id,
                        reason: this.decline_reason,
                    }

                    axios.post(REJECT_QUOTE_URL, payload,{
                        headers: this.headers
                    })
                    .then(response => {
                    if (response.data.status === 'success') {
                            this.show_success('Quote accepted successfully, your administrator will be in contact for the next step ');
                        }
                        else {
                            this.show_error('Error accepting quote: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        this.show_error("Error loading quotes: " + (error.response?.data?.message || error.message));
                    });
                }
            )
        }
    }
}